import { render, staticRenderFns } from "./InitConversationModal.vue?vue&type=template&id=07904fec&scoped=true"
import script from "./InitConversationModal.vue?vue&type=script&lang=js"
export * from "./InitConversationModal.vue?vue&type=script&lang=js"
import style0 from "./InitConversationModal.vue?vue&type=style&index=0&id=07904fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07904fec",
  null
  
)

export default component.exports